import React from 'react';
import { Button } from 'antd';
import { PrinterOutlined } from '@ant-design/icons';

import AssetHelper from '../../../../helpers/asset';
import GeneralHelper from '../../../../helpers/general';

const PrintButton = ({ ...rest }) => {
	const query = GeneralHelper.getParamsFromUrl();
	
	return (
		<Button
			{...rest}
			onClick={() => window.open(AssetHelper.getApplicationPdfDownloadUrl(query.application_id), '_blank')}
			type="primary"
			ghost
		>
			<PrinterOutlined style={{ fontSize: '14px' }}/> <span style={{ fontWeight: 510 }}>Print</span>
		</Button>
	);
};

export default PrintButton;